import React from 'react';
import './Container.css';


const Container = (props) => {

    return (
        <div className="tsg-container" id={props.containerId}>
            {props.children}
        </div>
    );
}

export default Container;